import { Component, OnInit } from '@angular/core';
import {TranslationContainerComponent} from '../../../../components/abstract/translation-container.component';
import {FiltersService} from '../../../../services/filters.service';
import {orderCall} from '../../../../../core/utils/utils';
import {ApplicationContextService} from '../../../../../core/services/impl/configuration/application-context.service';
import {NavigateManagerService} from '../../../../../core/services/navigate-manager.service';

@Component({
  selector: 'app-no-offers-tile',
  templateUrl: './no-offers-tile.component.html',
  styleUrls: []
})
export class NoOffersTileComponent extends TranslationContainerComponent implements OnInit {

  header: string;
  title: string;
  description: string;
  actionButtonLabel: string;

  get isAgentContextWithPartner(): boolean {
    return this.contextService.isAgentContextWithPartner;
  }

  get shouldRedirectToDetailsStep(): boolean {
    return this.isAgentContextWithPartner;
  }

  constructor(private filtersService: FiltersService,
              private contextService: ApplicationContextService,
              private navigateManager: NavigateManagerService) {
    super('NO_OFFERS_TILE');
  }

  ngOnInit() {
    this.initTranslations();
  }

  onActionButtonClick(): void {
    if (this.shouldRedirectToDetailsStep) {
      this.navigateManager.moveToFirstStep();
    } else {
      orderCall();
    }
  }

  clearFilters(): void {
    this.filtersService.resetFilters();
  }

  private initTranslations(): void {
    this.header = this.isAgentContextWithPartner ? this.getTranslationKey('agentContextHeader') : this.getTranslationKey('header');
    this.title = this.isAgentContextWithPartner ? null : this.getTranslationKey('title');
    this.description = this.isAgentContextWithPartner ? this.getTranslationKey('agentContextDescription') : this.getTranslationKey('description');
    this.actionButtonLabel = this.isAgentContextWithPartner ? this.getTranslationKey('backToCalculation') : this.getTranslationKey('orderCall');
  }

}
